import React from 'react';
import styled from 'styled-components/native';

const StyledView = styled.View<{ top: number; right: number }>`
  position: absolute;
  background-color: #ff5385;
  width: 20px;
  height: 20px;
  border-radius: 100px;
  align-items: center;
  justify-content: center;
  top: ${p => p.top}px;
  right: ${p => p.right}px;
`;

export const StyledText = styled.Text`
  font-family: 'WorkSans-SemiBold';
  font-size: 14px;
  line-height: 17px;
  color: white;
`;

export type IconBadgeProps = {
  value: number;
  top?: number;
  right?: number;
};

const IconBadge: React.FC<IconBadgeProps> = ({ value, top, right }) => {
  return (
    <StyledView
      top={typeof top === 'number' ? top : 0}
      right={typeof right === 'number' ? right : 0}
    >
      <StyledText>{value}</StyledText>
    </StyledView>
  );
};

export default IconBadge;
